<template>
  <div class="upload-file">
    <upload-files
      :min="issue.min"
      :max="issue.max"
      v-model="issue.uploadFiles"
      :check-file-type="issue.checkFileType"
      :allow-types="issue.allowFileTypes"
      :upload-file-max-size="question.uploadFileMaxSize"
    />
  </div>
</template>

<script>
import UploadFiles from '@/questions/components/UploadFiles'

export default {
  name: 'UploadFile',
  changeExpr: 'issue.uploadFiles',
  components: { UploadFiles }
}
</script>
